import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const ScrollToTopOnMount = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};
export const ScrollToBottomOnMount = () => {
  useEffect(() => {
    window.scrollTo(100, 100);
  }, []);
};
